// Mark'n'Post — Flex CIS (СНГ) corridor field rules. Pure predicates only:
// cyrillic name/address validators + СНГ phone length check. No IO.
// Русская кириллица only (А-Яа-яЁё); широкие алфавиты СНГ — отдельный слайс.
/**
 * Кириллическое имя: после trim длина 2..120 включительно и каждый символ —
 * русская кириллица (А-Яа-яЁё), пробел, дефис, апостроф или точка.
 */
export function isCyrillicName(s) {
    const trimmed = s.trim();
    if (trimmed.length < 2 || trimmed.length > 120)
        return false;
    return /^[А-Яа-яЁё .'\-]+$/.test(trimmed);
}
/**
 * Кириллический адрес: после trim длина 1..200 включительно и каждый символ —
 * русская кириллица (А-Яа-яЁё), цифра, пробел или один из знаков . , - / № ( ).
 */
export function isCyrillicAddressText(s) {
    const trimmed = s.trim();
    if (trimmed.length < 1 || trimmed.length > 200)
        return false;
    return /^[А-Яа-яЁё0-9 .,/№()\-]+$/.test(trimmed);
}
/** Требуемое число цифр локального номера по коду страны (СНГ). */
export const CIS_PHONE_DIGIT_COUNT = {
    "+7": 10,
    "+375": 9,
};
/**
 * СНГ-телефон валиден, если phoneCode входит в CIS_PHONE_DIGIT_COUNT и число
 * десятичных цифр в phoneLocal (прочие символы игнорируются) равно требуемому.
 * Ведущая «8» НЕ нормализуется (это забота слоя формы).
 */
export function isValidCisPhone(phoneCode, phoneLocal) {
    const expected = CIS_PHONE_DIGIT_COUNT[phoneCode];
    if (expected === undefined)
        return false;
    const digitCount = (phoneLocal.match(/[0-9]/g) ?? []).length;
    return digitCount === expected;
}
//# sourceMappingURL=cisFields.js.map